import api from '../api';

// Prepojené účty — tá istá osoba má účet vo viacerých firmách/okruhoch
// (users.person_id). Prepína sa bez hesla; pracuje sa vždy v JEDNOM okruhu,
// doklady sa medzi okruhmi nemiešajú.
export interface LinkedAccount {
  userId: string;
  tenantName: string;
  tenantSlug: string;
  logoUrl: string | null;
  role: string;
  current: boolean;
  pending: number;
}

export async function fetchLinkedAccounts(): Promise<LinkedAccount[]> {
  try {
    const r = await api.get('/auth/linked-accounts');
    return Array.isArray(r.data) ? r.data : [];
  } catch {
    return [];
  }
}

// Prepne prihlásenie na prepojený účet. Zahodí všetko, čo patrilo starému
// účtu (capture token, cache funkcií firmy) — inak by mobilný zber alebo
// moduly bežali pod predošlou firmou.
export async function switchAccount(userId: string): Promise<void> {
  const r = await api.post('/auth/switch-account', { userId });
  localStorage.setItem('token', r.data.token);
  localStorage.setItem('user', JSON.stringify(r.data.user));
  if (r.data.refreshToken) localStorage.setItem('refresh_token', r.data.refreshToken);
  localStorage.removeItem('capture_token');
  localStorage.removeItem('capture_identity');
  try { sessionStorage.removeItem('tenant_features'); } catch { /* ignore */ }
}
